import { theme, darktheme } from "./theme";

const config = {
  darkMode: true,
  theme,
  darktheme,
  panelView: "sidebar",
};

export default config;
